import React, { useState, cloneElement } from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  CreateButton,
  ShowButton,
  Filter,
  TextInput,
  BooleanField,
  SelectInput,
  GET_ONE,
  useRecordContext,
  useResourceContext,
  useTranslate,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../spinner";
import myDataProvider from "../myRestProvider";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption,getLocalStorageKey } from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const ClickItUserFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="business_id"
      reference="businesses"
      linkType="show"
      allowEmpty
      // label="Sold To"
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <TextInput source="first_name" />
    <TextInput source="last_name" />
    {/* <TextInput source="ship_to_sap_number" label="Ship To ID" /> */}
    <TextInput source="phone" />
    <TextInput source="email" />
    <SelectInput
      source="status"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
    />
  </Filter>
);

const CustomShowButton = () => {
  const record = useRecordContext();
  const resource = useResourceContext();
  console.log("recordrecordrecord", record);
  // basePath
  return (
    <div>
      {/* <ShowButton to={`${resource}/${record?.user_id}/show`} /> */}
      <ShowButton resource="users" record={{ id: record?.user_id }} />
    </div>
  );
};

const RoleName = (props) => {
  const record = useRecordContext();
  return <span>{record?.role_name.replace(/_/g, " ")}</span>;
};

const LoyaltyPoints = (props) => {
  const record = useRecordContext();
  return <span>{record?.balance_points || 0}</span>;
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     const [modalShow, setModalShow] = useState(false);
  //     const [modalMsg, setModalMsg] = useState("");
  //     const [customFilterUrl, setCustomFilterUrl] = useState('filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D');
  // }

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(location.search);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_list_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");

      setCustomFilterUrl(_url[1], () => {
        fetch(`${apiUrl}/${resource}_list_csv?${customFilterUrl}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
            //   this.setState({ modalShow: true});
            //   this.setState({ modalMsg: msg});
          });
      });
      // this.setState({ customFilterUrl: _url[1] }, () => {
      //   fetch(
      //     `${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`,
      //     options
      //   )
      //     .then((res) => {
      //       return res.json();
      //     })
      //     .then((jsonD) => {
      //       console.log("json= inside callback", jsonD.data);
      //       const msg = jsonD.data ? jsonD.data[0].message : "";
      //       Swal.fire({
      //         html: msg,
      //         icon: "success",
      //       });
      //       //   this.setState({ modalShow: true});
      //       //   this.setState({ modalMsg: msg});
      //     });
      // });
    } else {
      setCustomFilterUrl(location.search);
      fetch(`${apiUrl}/${resource}_list_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_list_csv";
  const translate = useTranslate();

  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
        <CreateButton basePath={basePath} />
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>{translate("resources.users.fields.export")}</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const ClickItUserList = (props) => {
  const translate = useTranslate();
  const userLocale = getLocalStorageKey("locale");

  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          // {...props}
          // exporter={props.exporter}
          sort={{ field: "created_at", order: "DESC" }}
          filters={<ClickItUserFilter />}
          title={translate("resources.users.fields.clickit_user")}
          // bulkActionButtons={false}
          resource="users"
          actions={<ListActions permissions={props} />}
        >
          <Datagrid bulkActionButtons={false} rowClick="show">
            {/* <CustomShowButton /> */}
            {/* <ShowButton /> */}
            <TextField source="first_name" />
            <TextField source="last_name" />
            <TextField source="phone" sortable={false} allowEmpty />
            <TextField source="email" allowEmpty />
            {
              userLocale == "en-GB" &&
              <LoyaltyPoints source="balance_points" label="Loyalty Points" />
            }
            {/* <ReferenceField
              source="principle_id"
              reference="businesses"
              link="show"
              allowEmpty
              label="Sold To Name"
            >
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField
              source="principle_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="sap_code" />
            </ReferenceField> */}
            {/* <TextField label="Role name" source="role_name" allowEmpty /> */}
            <RoleName label="Role name" source="role_name" />
            <DateField
              // label={"Created at"}
              source="created_at"
              allowEmpty
            />
            <BooleanField source="status" />
          </Datagrid>
        </List>
      </Scrollbars>
    </React.Fragment>
  );
};

export default ClickItUserList;
